import Data from "../Data";
import StyleItem from "../StyleItem";
import "../Taketour.css";
import heroSites from "../../../../assets/images/hero-sites.png"

const Sites = () => {
  const { sitesData } = Data();

  return (
    <div>
      {sitesData.map((item, index) => (
        <StyleItem key={index} data={item} />
      ))}
      <div className="taketour-image-section">
        <img src={heroSites} alt="" />
      </div>
    </div>
  );
};

export default Sites;
